import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy bookmark redirect. Pre-FSU `/admin/finance/expenditures` lands at
// the unified transactions workspace's staged pivot — same destination the
// FPD-028 `$expenditureId` drilldown route reaches, just without an id.
export const Route = createFileRoute('/admin/finance/expenditures/')({
  beforeLoad: () => {
    throw redirect({
      to: '/admin/finance/transactions',
      search: { status: 'staged' as const, view: 'match' as const },
    });
  },
});
